var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.10449H5M5 6.10449H21M5 6.10449V20.1045C5 20.6349 5.21071 21.1436 5.58579 21.5187C5.96086 21.8938 6.46957 22.1045 7 22.1045H17C17.5304 22.1045 18.0391 21.8938 18.4142 21.5187C18.7893 21.1436 19 20.6349 19 20.1045V6.10449H5ZM8 6.10449V4.10449C8 3.57406 8.21071 3.06535 8.58579 2.69028C8.96086 2.31521 9.46957 2.10449 10 2.10449H14C14.5304 2.10449 15.0391 2.31521 15.4142 2.69028C15.7893 3.06535 16 3.57406 16 4.10449V6.10449M10 11.1045V17.1045M14 11.1045V17.1045",
    stroke: "#7A8580",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.c0d11aa910fa1f02b3786e32fe480010.svg";
export { ForwardRef as ReactComponent };